import * as React from 'react';
import { connect } from 'react-redux';
import NavBar from './NavBar';
import Container from './Container';
import SideBar from './Sidebar/SideBar';
import NotificationHubLoader from './Notificaciones/NotificationHubLoader';
const FloatingChatSupport = React.lazy(() => import('./Usuarios/FloatingChatSupport')); 


class Landing extends React.Component {
  render() {
    return (
      <div className="App" id="main-wrapper">
        <NavBar idSeller={this.props.idSeller} user={this.props.user} />
        <SideBar />
        <Container />
        <React.Suspense fallback={null}>
          <FloatingChatSupport />
        </React.Suspense>
        <NotificationHubLoader userId={this.props.user?.userId} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  idSeller: state.general?.idSeller,
  user: state.general,
});

export default connect(mapStateToProps)(Landing);
